module.exports = __webpack_public_path__ + "img/bg-essae.b6f9ab8c.jpg";